module.exports = __webpack_public_path__ + "static/nklnew-9b4871d39a41bcba502c1330d39df522.png";